import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ReviewCard from '@/components/base/ReviewCard';
import { aboutReviews, reviews, stats } from '@/mocks/reviews';
import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-flashlight-line',
    title: '一手爆料',
    description: '遍布全网的爆料线索网络，确保第一时间获取最新吃瓜资讯，让你永远比朋友先知道。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方验证',
    description: '每一条爆料都经过编辑团队的多方交叉验证，确保内容的真实性和可信度，对假瓜零容忍。',
  },
  {
    icon: 'ri-speed-line',
    title: '极速更新',
    description: '7×24小时全天候更新机制，重大爆料事件发生5分钟内完成采编发布，绝不让瓜凉掉。',
  },
  {
    icon: 'ri-group-line',
    title: '瓜友社区',
    description: '活跃的吃瓜社区氛围，千万瓜友实时互动讨论，让吃瓜不再是一个人的狂欢。',
  },
  {
    icon: 'ri-eye-line',
    title: '深度扒皮',
    description: '专业的内容团队擅长深度挖掘，从蛛丝马迹中还原事件全貌，带来最有料的吃瓜体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持Web、APP、小程序多端同步阅读，无论在哪都能随时打开吃瓜，体验无缝衔接。',
  },
];

export default function About() {
  return (
    <>
      <Navbar />

      <main>
        {/* Breadcrumb */}
        <div className="bg-background-50 pt-24 pb-4">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-400" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* About Intro + Stats */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mb-16">
              <h1 className="text-3xl md:text-5xl font-heading font-black text-foreground-900 leading-tight mb-6">
                关于<span className="italic text-primary-500">52吃瓜网</span>
              </h1>
              <div className="space-y-4 text-base md:text-lg text-foreground-600 leading-relaxed">
                <p>
                  52吃瓜网成立于2024年，是国内领先的娱乐八卦与网红爆料资讯聚合平台。我们以"让每颗瓜都值得吃"为核心理念，致力于为广大吃瓜群众提供最新、最全、最真实的娱乐爆料和网红资讯。
                </p>
                <p>
                  在信息爆炸的时代，真假难辨的爆料充斥着整个网络。52吃瓜网坚持<strong>内容为王、真实为本</strong>的原则，通过专业的编辑团队和严格的内容审核机制，确保每一条推送给用户的信息都经过充分的事实核查和多方验证，力求为用户呈现最接近真相的内容。
                </p>
                <p>
                  经过两年的快速发展，52吃瓜网已经积累了超过<strong>500万月活跃用户</strong>，发布了<strong>3000余篇独家爆料文章</strong>，与<strong>200多家媒体</strong>建立了合作关系，成为中文互联网上最具影响力的吃瓜资讯平台之一。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-3xl md:text-5xl font-heading font-black text-foreground-900 mb-2">
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12 md:mb-16">
              <p className="text-sm text-foreground-400 font-medium tracking-wide mb-3">
                为什么选择我们
              </p>
              <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-900 leading-tight">
                52吃瓜网
                <br />
                吃瓜新体验
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {features.map((feature) => (
                <div
                  key={feature.title}
                  className="bg-background-100 rounded-2xl p-6 md:p-8 transition-all duration-300 hover:scale-[1.02]"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100/70 flex items-center justify-center mb-5">
                    <i className={`${feature.icon} text-primary-500 text-xl md:text-2xl`}></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation / Reviews */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-left mb-12">
              <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
                口碑见证
              </span>
              <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-900 leading-tight">
                听听他们的
                <br />
                真实评价
              </h2>
            </div>
            <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
              {aboutReviews.map((review) => (
                <ReviewCard key={review.id} review={review} />
              ))}
              {reviews.slice(0, 3).map((review) => (
                <ReviewCard key={review.id} review={review} />
              ))}
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="relative w-full min-h-[450px] md:min-h-[500px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20stylized%20illustration%20of%20people%20connecting%20and%20communicating%20through%20digital%20devices%2C%20modern%20editorial%20digital%20art%2C%20warm%20amber%20and%20coral%20tones%2C%20community%20and%20collaboration%20concept%2C%20friendly%20atmosphere%2C%20contact%20us%20theme%2C%20inviting%20and%20professional%20vibe&width=1800&height=700&seq=about-cta-bg&orientation=landscape"
              alt="联系我们"
              title="联系52吃瓜网"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-foreground-900/55"></div>
          </div>
          <div className="relative w-full max-w-2xl mx-auto px-4 md:px-6 text-center py-16">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-background-50 leading-tight mb-4">
              有料要爆？加入我们！
            </h2>
            <p className="text-sm md:text-base text-background-200 leading-relaxed mb-8 max-w-md mx-auto">
              如果你有独家爆料线索或想加入52吃瓜网团队，<br />欢迎通过以下方式联系我们。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="mailto:hello@rdstudio.cn"
                className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-900 transition-all cursor-pointer whitespace-nowrap justify-center"
              >
                <i className="ri-mail-send-line"></i>
                投稿爆料
              </a>
              <a
                href="#download"
                className="inline-flex items-center gap-2 px-8 py-4 border-2 border-background-50/30 text-background-50 font-semibold text-sm rounded-full hover:border-background-50 hover:bg-background-50/10 transition-all cursor-pointer whitespace-nowrap justify-center"
              >
                <i className="ri-download-2-line"></i>
                下载APP
              </a>
            </div>
            <div className="mt-8 flex items-center justify-center gap-6">
              <div className="text-sm text-background-300">
                <i className="ri-mail-line mr-1"></i> hello@rdstudio.cn
              </div>
              <div className="text-sm text-background-300">
                <i className="ri-wechat-line mr-1"></i> 52chigua_wechat
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于52吃瓜网',
            description: '52吃瓜网是国内领先的娱乐八卦与网红爆料资讯聚合平台，致力于为广大吃瓜群众提供最新、最全、最真实的娱乐爆料。',
            url: 'http://rdstudio.cn/about',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'http://rdstudio.cn/' },
                { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://rdstudio.cn/about' },
              ],
            },
          }),
        }}
      />
    </>
  );
}